import useGet from "../useGet";
import { CompanySummary } from "../useCompanies/useCompanies";
import { BranchSummary } from "../useCompanyBranches/useCompanyBranches";
import { MoneyCorpPermissions } from "../usePermissions/usePermissions";

export type UserSummary = {
  id: number;
  firstName: string;
  lastName: string;
  company?: CompanySummary;
  branches?: BranchSummary[];
};

const useBranchPeople = (
  companyId: any,
  branchId: any,
  permissions: MoneyCorpPermissions,
  dependencies: any[]
) => {
  const hasPermission = permissions.admin;
  const { value, loading } = useGet(
    `/api/Companies/${companyId}/Branches/${branchId}/Users?ts=` +
      new Date().getTime(),
    "Unable to read branches for company/branch id: '" +
      companyId +
      "/" +
      branchId +
      "'",
    hasPermission ? null : [],
    [...dependencies, companyId, branchId, hasPermission],
    undefined,
    () =>
      companyId != null &&
      companyId !== "" &&
      branchId != null &&
      branchId !== "" &&
      hasPermission
  );

  return {
    branchPeople: value as UserSummary[],
    branchPeopleLoading: loading as boolean
  };
};

export default useBranchPeople;
